/**
 * High level router.
 *
 * Note: It's recommended to compose related routes in internal router
 * components (e.g: `src/app/modules/Auth/pages/AuthPage`, `src/app/BasePage`).
 */

import { lazy, useEffect } from "react";
import { shallowEqual, useDispatch, useSelector } from "react-redux";
import { Redirect, Route, Switch } from "react-router-dom";
import { actionLoginByToken } from "../redux/auth/actions";
import { Layout } from "../_metronic/layout";
import BasePage from "./BasePage";
import { AuthPage } from "./modules/Auth";

const ListDemoCanvasPrice = lazy(() =>
  import("./pages/Demo/ListDemoCanvasPrice")
);

export function Routes() {
  const dispatch = useDispatch();
  const { infoUser } = useSelector(
    (state) => ({
      infoUser: state.authReducer.infoUser,
    }),
    shallowEqual
  );

  const token = localStorage.getItem("token");

  useEffect(() => {
    (async () => {
      if (localStorage.getItem("token")) {
        await dispatch(actionLoginByToken());
      }
    })();
  }, [dispatch]);

  return (
    <>
      <Switch>
        {infoUser || token ? (
          <Layout>
            <BasePage />
          </Layout>
        ) : (
          <Switch>
            {/* Quản lý thống kê */}
            <Route path="/demo/price" component={ListDemoCanvasPrice} exact />
            {/* end */}
            <Route path="/login" component={AuthPage} />
            <Redirect to="/login" />
          </Switch>
        )}
      </Switch>
    </>
  );
}
